import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { ContractAdjustForm } from '../Contract.AdjustDistributions';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import { defaultInputDateFormat, defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import Icon from 'assets/components/icon/Icon';

const ContractAdjustDistributionsDates = () => {
  const { lang } = getLocales();
  const { form } = useModalForm<ContractAdjustForm>();

  return (
    <FormWrapper>
      <DateInput
        name="effectiveDate"
        label={lang.effectiveDate}
        value={form.data?.effectiveDate}
        error={form.errors?.effectiveDate}
        dateTimeFormat={defaultInputDateFormat}
        isLocal={true}
        onChange={({ effectiveDate }) => {
          form.update({ effectiveDate });
        }}
        icon={<Icon class="fas-calendar-alt" />}
      />
      <DateInput
        name="expiryDate"
        label={lang.expiryDate}
        value={form.data?.expiryDate}
        error={form.errors?.expiryDate}
        dateTimeFormat={defaultInputDateFormat}
        isLocal={true}
        onChange={({ expiryDate }) => {
          form.update({ expiryDate });
        }}
        icon={<Icon class="fas-calendar-alt" />}
      />
      <DateInput
        name="createdAtLocal"
        label={lang.createdAtLocal}
        value={form.data?.createdAtLocal}
        error={form.errors?.createdAtLocal}
        dateTimeFormat={defaultInputDateTimeFormat}
        isLocal={true}
        onChange={({ createdAtLocal }) => {
          form.update({ createdAtLocal });
        }}
        icon={<Icon class="fas-calendar-alt" />}
      />
    </FormWrapper>
  );
};

export default ContractAdjustDistributionsDates;
